

    require('./heatmap/HeatmapSeries');
    require('./heatmap/HeatmapView');



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/heatmap.js
// module id = o0k+
// module chunks = 5